module.exports = __webpack_public_path__ + "static/media/trifolium-mechanism.61d14dbf.gif";